import { ApiUrls } from "appConstants/apis";
import { Customer } from "models/customer/Customer";
import { CustomerTabs } from "pages/backoffice/Customer/List/types";
import { BaseServices } from "./baseServices";

export class CustomerService extends BaseServices<Customer> {
	constructor() {
		super(Customer);
	}

	getList(tab: CustomerTabs, filters: any): any {
		try {
			return super
				.listPaginated(ApiUrls.customers.getList(tab), filters)
				.then((response) => response);
		} catch (error) {
			return undefined;
		}
	}

	getCustomerDetails(id: string): any {
		return super
			.get(ApiUrls.customers.getCustomerDetails(id))
			.then((response) => {
				const customer = Customer.createFromResponse(response);
				return customer;
			});
	}

	createResourcesFromListResponse(results: any[]): Customer[] {
		return results.map((data) => Customer.createFromResponse(data));
	}
}
